import { IA_KEY } from 'helpers/ia-logic';

import ModifierEditorPage from './ModifierEditorPage';
import { watchActions } from './Modifiers.saga';

const commonConfig = {
  component: ModifierEditorPage,
  iaKey: IA_KEY.SKU_MODIFIERS,
  pathSagas: [watchActions],
};

export default [
  {
    path: '/items/:venueId/modifiers/new',
    ...commonConfig,
  },
  {
    path: '/items/:venueId/modifiers/:groupId',
    ...commonConfig,
  },
];
